import React, {useEffect, useLayoutEffect, useReducer, useRef} from 'react';
import './CourseCatalog.css';
import axios from 'axios'; 
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { TextField, Switch, FormControlLabel} from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import moment from 'moment';
import InfoIcon from '@material-ui/icons/Info';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import { Accordion, AccordionDetails, Typography, AccordionSummary} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
 
  formControl: {
    margin: theme.spacing(1),
    minWidth: 140,
    marginTop:0, 
  },
  root: {
    display: 'flex',
  },
  paperFilter: {
    maxWidth: 180,
    position: 'fixed',
    right: 30,
    padding: 10,
    

  },
  paperSelects: {
     
  },

  drawer:{
    width:600,
    listStyle:'none',
    padding:0,
    margin:0,
    height:"100%",
  },


  listContainer:{
      margin: 0,
      listStyle: 'none',
      padding: 0,
      maxWidth:573,
  
  },

  listContainerMobile:{
    width:340,
    listStyle:'none',
    padding:0,
    margin:0,
    height:"100%",
  },

  listItem:{
    marginTop:2,
  },

  courseDetails:{
    width: 800,
  },

  button:{
    background:828282,
  }, 

  courseOfferingHeading: {
    paddingLeft:20, 
    marginBottom:5,
  },

  courseOffering:{
    overflow:'hidden',
  },

  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
    height:15,
    color:'#fff',
    backgroundColor:'#005cab',
  }, 
  offCampus:{
    color:"#EB0000",
    maxHeight:18,
    position:'relative',
    marginLeft:-3,
    top:3,
   
  }, 
  info:{
    color:"#777777",
    maxHeight:18,
    position:'relative',
    marginLeft:-3,
    top:3,

  },
  courseButton:{
    '&:focus':{
        background: "#005cab",
        color: "white",
    },
  },
  link:{
    '&:focus':{
      textDecoration:'underline',
    },

   }
  

}));

//#region State Logic

 function renderIAI(gcc){


  const letter = gcc.charAt(0);

  switch(letter){
    case 'C':
      return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiCom2.svg"  alt="Communications IAI Course"/>
    
    case 'F':
        return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiArt1.svg" alt="Fine Arts IAI Course"/>
     
    case 'H':
        return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiHumanities1.svg"  alt="Humanities IAI Course"/>
    
    case 'L':
        return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiLifeScience1.svg" alt="Life Sciences IAI Course"/>
  
    case 'M':
        return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiMath1.svg" alt="Math IAI Course"/>
      
    case 'P':
        return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiPhysicalScience1.svg"  alt="Physical Sciences IAI Course"/>
  
    case 'S': 
         return <img style={{"width": "20px"}} src="https://www.heartland.edu/courseDescriptions/images/iaiSocialSciences1.svg"  alt="Social Sciences IAI Course"/>
    default: return <p></p>;
  }

}

function transfer(type){

  switch(type){

    case 'CTE': 
      return <p><strong>Career and Technical Course</strong>: This course is a specific requirement for an Associate of Applied Science or certificate program and may not transfer. Please consult with your advisor about transferability.
      </p>

    case 'DEVED': 
      return <p><strong>Developmental Course</strong>: This course is not college level and will not transfer or count towards a degree or certificate program.</p>
    
    case 'GECC':
      return <p><strong>Transferrable General Education Course</strong>: This course generally should transfer to an Illinois Articulation Initiative college or university. Please consult with your advisor about transferability.</p>
    
    case 'TRNSFR': 
      return <p><strong>Transferrable Elective Course</strong>: This course generally should transfer to an Illinois Articulation Initiative college or university. Please consult with your advisor about transferability.</p>

    default: 
      break;
  }
 

}

const filterCourses = (state, action) => {

  switch(action.type){
    case 'initCourses':
      return {...state, allCourses: action.payload, courses : action.payload}

    case 'initMAFilteredCourses':
      return {...state, allCourses: action.payload, courses: action.payload.filter(item => (action.filter.includes(item.SUBJECT)) && (item.SUBJECT !== "MA") )}   
    

    case 'initFilteredCourses':   
      return {...state, allCourses: action.payload, courses: action.payload.filter(item => action.filter.includes(item.SUBJECT) )}   
    
    case 'initFilteredByIAI':
      return {...state, allCourses:action.payload, courses: action.payload.filter(item => (item.GECC_CODE) && (item.GECC_CODE.charAt(0) === action.filter )) }

    case 'initSingleCourse':
      return {...state, allCourses:action.payload, courses: action.payload.filter(item => item.SUBJECT === action.filter && item.CATALOG_NBR.toString() === action.catNum)}
      
    case 'initNav':
        return {...state, allNavMenu: action.payload}

    case 'initFilteredNav':
          return {...state, allNavMenu: action.payload, navMenu: action.payload.filter(item => item.Code === action.filter)}
      
    case 'initContacts':
        return {...state, allContacts: action.payload}

    case 'initFilteredContacts':
        return {...state, allContacts:action.payload, contacts: action.filtered}
        
    case 'initSubjectsDDL':
        return {...state, subjectsDDL: action.payload}

    case 'updateCourses': 
        return {...state, courses:action.courses }

    case 'updateSubject':
        return {...state, subjectTags:action.tags, subjectsSelected:action.subjectsSelected }
    
    case 'updateGenEds':
        return {...state, iaiGenEdTags:action.tags, iaiGenEdsSelected:action.gensSelected}

    case 'updateGECC':
      
      return {...state, courses : action.payload.filter(item => item.TRANSFER_TYPE === 'GECC')} 

    case 'updateGECCType':

      return {...state, courses: action.payload}


    case 'filterIAI':
      return {...state, courses:action.payload}


    // case 'updateNav': 
    //      let nav = state.allNavMenu.filter(item => item.Code === action.filter);
    //      return {...state, navMenu: nav} 
         
    case 'updateCredits':
   
          return {...state, creditTags:action.creditTags, creditsSelected:action.creditsSelected }
    
    case 'setSubject':
          return {...state, courses: action.payload}     

    case 'search':
          return {...state, searchVal:action.searchVal}

    case 'addClass':
          return {...state, classes:action.classes}

    case 'drawerAction': 
          return {...state, drawerOpen:action.payload}

    case 'clear': 
          return {...state, courses:state.allCourses, subjectsSelected:[], subjectTags:[], creditTags:[], creditsSelected:[], iaiGenEdTags:[], iaiGenEdsSelected:[], searchVal:''}

    case 'noClasses':
          return {...state, noClasses:action.noClasses}
          
    default: return state;
  }

}

//#endregion

//#region Component
function CourseCatalog() {
    
//#region State Declarations
    const classes = useStyles();
    const [state, dispatch] = useReducer(filterCourses, {
      allCourses: [],
      courses: [],
      unfilteredCourses: [],
      allNavMenu: [],
      navMenu:[],
      allContacts: [],
      contacts: [],
      subjectsDDL:[],
      classes:[],
      iAIGenEdsDDL:[
        {value:'iai-Communications', name: 'Communications'}, 
        {value:'iai-Humanities', name:'Humanities'}, 
        {value: 'iai-Fine Arts', name:'Fine Arts'}, 
        {value: 'iai-Mathematics', name:'Mathematics'}, 
        {value: 'iai-Life Science', name:'Life Sciences'}, 
        {value: 'iai-Physical Science', name:'Physical Sciences'}, 
        {value:'iai-Social and Behavioural Sciences', name:'Social and Behavioral Sciences'},
      ], 
      creditHoursDDL: ['1.00', '2.00', '3.00', '4.00', '5.00', '6.00', '7.00', '8.00', '9.00', '10.00'],
      drawerOpen: false,
      classDetails:[],
      subjectsSelected:[],
      iaiGenEdsSelected:[],
      creditsSelected:[],
      subjectTags:[],
      iaiGenEdTags:[],
      creditTags:[], 
      noClasses:null,

      searchVal:'',
    }); 

    const allCoursesRef = useRef(state.allCourses);
    const coursesRef = useRef(state.courses); 

    const subjectTags = useRef(state.subjectTags); 
    const iaiGenEdsRef = useRef(state.iaiGenEdTags);
  
    const [iaiChecked, setIaiChecked] = React.useState(false);
    const iaiCheckedRef = useRef(iaiChecked);

    const creditRef = useRef(state.creditTags);

    const classesRef = useRef(state.classes);
    const noClassesRef = useRef(state.noClasses);

    const [expanded, setExpanded] = React.useState(false);
    

    let searchT = React.useRef(state.searchVal);

//#endregion

//#region Handlers

//#region Search Text
const matches = useMediaQuery('(min-width:590px)');



const toggleDrawer = (open, subject, number) => (event) => {



  if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
  return;
  }

  if(open){

  fetchSchedule(subject, number); 



  } else{
  dispatch({type:'addClass', payload:[]});
  dispatch({type:'noClasses', noClasses:false});
  }
  dispatch({type:'drawerAction', payload:open });

  
};

const handleSearchText = event => {
  
  dispatch({type:"search", searchVal:event.target.value});

}

const clear = () => {

  setIaiChecked(false);
  dispatch({type:'clear'});
}



//#endregion

    const handleChangeIAI = event => {

      setIaiChecked((prev) => !prev);

      };
  

//#endregion

//#region IAI Gen Eds

const handleChangeIAIType = event =>  {

     let tags = iaiGenEdsRef.current;
     let diff = state.iaiGenEdsSelected.filter(item => !event.target.value.includes(item)); 
     

     if(diff.length){
       tags = tags.filter(item => !item.includes(diff));
     }

     event.target.value.forEach(val => tags.push(val)); 

     let newTags = [...new Set(tags)];

     dispatch({type:"updateGenEds", tags:newTags, gensSelected:event.target.value });

    }

const handleCredits = event => {

    let tags = creditRef.current; 
    let diff = state.creditsSelected.filter(item => !event.target.value.includes(item)); 

    if(diff.length){
      console.log(diff);

      tags = tags.filter(item => !item.includes(diff)); 
    }

    event.target.value.forEach(val => tags.push(val)); 

    let creditTags = [...new Set(tags)]; 

    dispatch({type:"updateCredits", creditTags:creditTags, creditsSelected:event.target.value}); 

}

const handleExpand = (panel) => (event, isExpanded) => {

  if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    return;
    }

  setExpanded(isExpanded ? panel : false);
}


//#endregion

//#region Change Subject

    const handleChangeSubject = event => {  
        
        let tags = state.subjectTags; 

        let diff = state.subjectsSelected.filter(item => !event.target.value.includes(item)); 

        if(diff.length){
          tags = tags.filter(item => !item.includes(diff));
        }

        event.target.value.forEach(val => {
          tags.push(val);
       });

        let newTags = [...new Set(tags)]; 

        dispatch({type:'updateSubject', tags:newTags, subjectsSelected:event.target.value});  

    }


    function filterCourseDescriptions (tag1, tag2, tag3, search, courses){

        if(tag1.length){
          
          courses = courses.filter(course => Object.values(course).some(v => tag1.includes(v)));
        }

        if(tag2.length){
          courses = courses.filter(course => Object.values(course).some(v => tag2.includes(v)));
        }

        if(tag3.length){
          courses = courses.filter(course => Object.values(course).some(v => tag3.includes(v)));
        }

        courses = [...new Set(courses)];

        if(iaiCheckedRef.current){  
         courses = courses.filter(item => item.GECC_CODE != null);
        }
  
        
        if(state.iaiGenEdTags.length){
          courses = courses.filter(course => course.GECC_CODE != null); 
        }

        if(search !== ''){
          
          search = search.toLowerCase();

          courses = courses.filter(item => item.CATALOG_DESCR.toLowerCase().includes(search) || item.CRSE_ID.toLowerCase().includes(search) || item.SUBJECT_LONG.toLowerCase().includes(search) || item.SUBJECT.toLowerCase().includes(search) || item.CATALOG_NBR.toString().includes(search) ||  item.CREDIT_HRS.toString().includes(search) || item.COURSE_TITLE_LONG.toLowerCase().includes(search) || (item.SUBJECT.toLowerCase() + ' ' + item.CATALOG_NBR.toString()).includes(search)); 
        
        
          courses.sort((a,b) => {
            let valA = '';
            let valB = ';'
            if ( a.SUBJECT.toLowerCase().includes(search) || (a.SUBJECT.toLowerCase() + ' ' + a.CATALOG_NBR.toString()).includes(search) || a.COURSE_TITLE_LONG.toLowerCase().includes(search) ){
              valA = 0;
            } else {
              valA = 1; 
            }
        
            if(b.SUBJECT.toLowerCase().includes(search) || (b.SUBJECT.toLowerCase() + ' ' + b.CATALOG_NBR.toString()).includes(search) || b.COURSE_TITLE_LONG.toLowerCase().includes(search) ){
              valB = 0; 
            } else {
              valB = 1; 
            }
           return valA - valB; 
          }
        
          );

        }

        dispatch({type:'updateCourses', courses:courses}); 

    }

//#endregion

//#endregion

//#region Effect Hooks

    useLayoutEffect( () => {

      const exp =  /^[A-Za-z]{0,44}$/;
      const numExp = /^[0-9]{0,3}$/;
      const regex = new RegExp(exp);  
      const numRegex = new RegExp(numExp);
      const search = window.location.search; 
      const params = new URLSearchParams(search);
      var subject = params.get('subject');
      var gecc = params.get('gecc');
      var catNum = params.get('catalog_nbr'); 
      
      if( subject && !subject.match(regex)){
        subject = null; 
      } else if (subject)
      {  
        subject = subject.toUpperCase();
      }

      if( gecc && !gecc.match(regex)){
        gecc = null; 
      } else if (gecc)
      {  
        gecc = gecc.charAt(0).toUpperCase();
      }

      if(catNum && !catNum.match(numRegex)){
        catNum = null;
      }

      const fetchSubjects = async () => {
        try{
          const result = await axios({ 

            method:'get',  
  
            headers:{'Content-Type':'application/json',  
  
            'X-DreamFactory-Api-Key':'c7bbafa3068cc7485782a2f7ad4484ff3ca5320e126a87aad1522d390fac5cf5'},  
  
            crossDomain: true,  
  
            url:'https://dfprd.heartland.edu/api/v2/k2_smartboxdata/_table/IT_CreditSubjects?order=SUBJECT_LONG%20ASC'  
  
          }); 
        
          if(subject){
          dispatch ( {type: 'initSubjectsDDL', payload:result.data.resource});  
          }
          else {
            dispatch ( {type: 'initSubjectsDDL', payload:result.data.resource}); 
          }


        } catch(error){
            console.log(error);
            const result = await axios.get('https://hcc-course-descriptions.s3.us-east-2.amazonaws.com/subjects.json'); 
            
            if(subject){
            dispatch ( {type: 'initSubjectsDDL', payload:result.data.resource});  
            }
            else {
            dispatch ( {type: 'initSubjectsDDL', payload:result.data.resource}); 
            }

          }
        };

      const fetchCatalog = async () => {

        try{
          const result = await axios({

            method:'get',
            headers:{
              'Content-Type': 'application/json',
              'X-DreamFactory-Api-Key':'ffd202d38516d346f75aa3f7b0f76749b36904f1b28a7f674a484f40a036280c'
            },
            crossDomain:true,
            url:'https://dfprd.heartland.edu/api/v2/irdb_k2/_table/WEB_CRSE_CATALOG?order=SUBJECT_LONG%20ASC%2CCATALOG_NBR%20ASC'

          }); 

          if(subject && catNum){

            return dispatch({type:'initSingleCourse', payload:result.data.resource, filter:subject, catNum:catNum});
          }


          if(subject){
            
          if( (subject.includes("TMAT")) || (subject.includes("MAIN")) ){
            return  dispatch( {type: 'initMAFilteredCourses', payload:result.data.resource, filter:subject}); 
          }

            return  dispatch( {type: 'initFilteredCourses', payload:result.data.resource, filter:subject}); 
          }
          if(gecc){
            return dispatch( {type:'initFilteredByIAI', payload:result.data.resource,filter:gecc});
          }
          else {
            dispatch ( {type: 'initCourses', payload:result.data.resource});   
          } 

         



      } catch(error) {
          console.log(error); 
          const result = await axios.get('/courses.json');    

          if(subject && catNum){
            return dispatch({type:'initSingleCourse', payload:result.data.resource, filter:subject, catNum:catNum});
          }
          if(subject){
            return dispatch( {type: 'initFilteredCourses', payload:result.data.resource, filter:subject}); 
          }
          if(gecc){
            return dispatch( {type:'initFilteredByIAI', payload:result.data.resource, filter:gecc});
          }
         
          else {
            dispatch ( {type: 'initCourses', payload:result.data.resource});   
          }

      }
  
       };

      

      
          
       fetchSubjects();     
       fetchCatalog();

    }, []); 

    useEffect( () => {

      coursesRef.current = state.courses;
      
    }, [state.courses]);

    useEffect( () => {

      allCoursesRef.current = state.allCourses;
      
    }, [state.allCourses]); 

    useEffect ( () => {

      subjectTags.current = state.subjectTags; 

      
      filterCourseDescriptions(subjectTags.current, iaiGenEdsRef.current, creditRef.current, searchT.current, allCoursesRef.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.subjectTags]);

    useEffect( () => {

      iaiGenEdsRef.current = state.iaiGenEdTags;
      // let courses = allCoursesRef.current;
     
      filterCourseDescriptions(subjectTags.current, iaiGenEdsRef.current, creditRef.current, searchT.current,  allCoursesRef.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.iaiGenEdTags] );

    useEffect(() => {
      iaiCheckedRef.current = iaiChecked;
      filterCourseDescriptions(subjectTags.current,  iaiGenEdsRef.current, creditRef.current, searchT.current, allCoursesRef.current); 
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iaiChecked]  );

    useEffect(() => {
      searchT.current = state.searchVal;
      
      filterCourseDescriptions(subjectTags.current,  iaiGenEdsRef.current, creditRef.current, searchT.current, allCoursesRef.current); 
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.searchVal]);

    useEffect(() => {

      creditRef.current = state.creditTags; 

      filterCourseDescriptions(subjectTags.current,  iaiGenEdsRef.current, creditRef.current, searchT.current, allCoursesRef.current); 

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.creditTags] );

    useEffect( () => {
      classesRef.current = state.classes;

    }, [state.classes] ); 

    useEffect ( () => {
      noClassesRef.current = state.noClasses;
    }, [state.noClasses]);

    const fetchSchedule = async (subject, number) => {
  
      try{
  
        const result = await axios({ 

          method:'get',  

          headers:{'Content-Type':'application/json',  

          'X-DreamFactory-Api-Key':'18604e220f1e023545f8ad5c5d1e67952a95d09a7063d5bb8640c75ac41d7889'},  

          crossDomain: true,  

          url:'https://dfprd.heartland.edu/api/v2/irdb_k2/_table/WEB_CLASS_SCHEDULE?filter=(SUBJECT='+subject+')and(CATALOG_NBR='+number+')&order=Start_Date DESC'   

        });   

        if(result.data.resource.length !== 0){
          dispatch({type:'addClass', classes:result.data.resource }); 
        }
        else {
         
          dispatch({type:'noClasses', noClasses:true}); 
        }
      } catch(error){
        console.log(error); 
        const result = await axios.get('schedule.json'); 
        dispatch({type:'addClass', classes:result.data.resource }); 

      }
  
  
    };
   
  
 
//#endregion

//#region JSX 





const list = () => (


  

    <ul className={  (matches) ? classes.listContainer: classes.listContainerMobile } >

  
    {
        (state.classes) && (state.classes.map( (item, index) => {
          
          const ident =  item.SUBJECT + item.CATALOG_NBR + item.CLASS_SECTION + item.STRM + item.LAST_NAME + item.FIRST_NAME + index;
             const time = (item.FACILITY_ID === "ONLINE" || item.FACILITY_ID === "HCC FLEX") ?  "":  item.CLASS_DAYS + " " + item.Start_Time + " - " + item.End_Time + "    |    ";
             const location = (item.FACILITY_ID === "ONLINE" || item.FACILITY_ID === "HCC FLEX") ?  "": item.FACILITY_ID + " | "; 
             const available = item.ROOM_CAP_REQUEST - item.ENRL_TOT ;
             const isClosed =  item.ENRL_CAP - item.ENRL_TOT;
             const pairedAvailable = item.ROOM_CAP_REQUEST - item.PAIRED_ENRL_TOT;
             const now = moment();


         return <li className={classes.listItem} key={ident+ "_div"}>
         
         <Accordion autoFocus className={classes.courseOffering} expanded={ expanded === ident } key={ident} onChange={handleExpand(ident)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordion} aria-controls={ident} id={ident}>

          <div className={classes.heading}>
          <Typography className={classes.heading}>{item.Term + " - " + item.SUBJECT + " " + item.CATALOG_NBR + " " + item.CLASS_SECTION + " - " + item.CLASS_TITLE } </Typography>
          
           
                <Typography className={classes.secondaryHeading}>{time} {(item.LOCATION === "PONTIAC" || item.LOCATION === "LINCOLN" ) ? 
                  <span ><InfoIcon className={classes.offCampus}  />{location}</span> : <span>{location}</span> 
                }{item.INSTRUCTION_MODE + " " + item.SECTION_TYPE}
                 </Typography>
              
              <Typography className={classes.secondaryHeading}>Instructor: {item.FIRST_NAME + " " + item.LAST_NAME} | Credit Hours: {item.Credit_Hours} {(item.CLASS_NBR) && " | Course Code:" +  item.CLASS_NBR}</Typography>
                
              { (isClosed > 0) && (item.PAIRED_FLAG) && <Typography className={classes.secondaryHeading}>Paired Seats Available: {  " " + pairedAvailable +  " / " + item.ROOM_CAP_REQUEST }</Typography>}

                {( (item.WAIT_CAP > 0) && (item.ENRL_TOT >= item.ENRL_CAP) ) ?  
                           
               
                (( moment(now, "MM-DD-YYYY").isSameOrAfter( moment(item.WAIT_LIST_END_DT, "MM-DD-YYYY") ) ) ? 
                <Typography className={classes.greyedOut}><strong>Waitlist Closed</strong></Typography> :
                <Typography className={classes.secondaryHeading}>Waitlist: {" " + item.WAIT_TOT +  " / " + item.WAIT_CAP }</Typography> ):


                

                (isClosed > 0) ? 
               
                <Typography className={classes.secondaryHeading}>Available Seats: {  " " + available +  " / " + item.ROOM_CAP_REQUEST }</Typography> : 
                (item.ENRL_CAP !== 0) ?
                <Typography className={classes.greyedOut}><strong>Class Full</strong></Typography> :   
                <Typography className={classes.greyedOut}><strong>Registration Closed</strong></Typography>
                }
              </div>
              </AccordionSummary>
              <AccordionDetails className="details">
                {(expanded === ident) &&
                <div>
                <Typography className={classes.secondaryHeading}><a className={classes.link}  href={"https://www.bkstr.com/webapp/wcs/stores/servlet/booklookServlet?bookstore_id-1=633&term_id-1=" + item.STRM +"&dept-1="+ item.SUBJECT +"&course-1="+ item.CATALOG_NBR +"&section-1="+ item.CLASS_SECTION} target="_blank" rel="noopener noreferrer" >Textbooks</a></Typography>
           
              <Typography className={classes.secondaryHeading}>Dates: {" "+ item.Start_Date + "-" + item.End_Date +  " " + item.CLASS_LENGTH}</Typography>
              {(item.CLASS_FEE) && <Typography className={classes.secondaryHeading}>Fees: {" $" + item.CLASS_FEE}</Typography>}
             { (item.CLASS_NOTE) && 
                <div>
                  {(item.LOCATION === "PONTIAC" || item.LOCATION === "LINCOLN") ? 
                    <Typography><InfoIcon title="Note" className={classes.offCampus}/> { " " + item.CLASS_NOTE}</Typography>:
                    <Typography><InfoIcon title="Note" className={classes.info} /> { " " + item.CLASS_NOTE}</Typography>
                  }
             </div>
            }
             
               </div> }</AccordionDetails>
            </Accordion>
        </li>
        }
          ))
        
      }
    </ul> 

 
  
);
    
  return (
    <div className="CourseCatalog main react-main-left-nav">

    <div className="main__content">
      <div className="main__content__indent-left">         
        
        <Grid container direction="column">
            <Grid item>    
        <FormControl className={classes.formControl}>
        <Grid container alignItems="center">
                    <Grid item>
                      <TextField id="search" inputRef={searchT.current.value} label="Search" 
                      onChange={handleSearchText} value={state.searchVal} />
                    </Grid>
                    <Grid item><div style={{ position: 'absolute', top: '22px', right: '1px' }}> <SearchIcon aria-hidden='true' /> </div> 
                    </Grid>
                    </Grid>
        </FormControl>

        <FormControl className={classes.formControl}>
        <InputLabel id="subject-label">Subject</InputLabel>
        <Select
          labelId="subject-label"
          id="subject"
          multiple
          value={state.subjectsSelected}
          onChange={handleChangeSubject}
          input={<Input />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value, index) => (
                <Chip key={index} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {
            state.subjectsDDL.map( (item, index) => (   
              <MenuItem key={index} value={item.SUBJECT} >{item.SUBJECT_LONG}</MenuItem>
            ) )
          }
         
        </Select></FormControl>

        <FormControl className={classes.formControl}>
        <InputLabel id="iai-gen-eds-label">IAI Gen Eds</InputLabel>
        <Select
          labelId="iai-gen-eds-label"
          id="iai-gen-eds"
          multiple
          value={state.iaiGenEdsSelected}
          input={<Input />}
          onChange={handleChangeIAIType}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value, index) => (
                <Chip key={index} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {
            state.iAIGenEdsDDL.map( (item, index) => (   
              <MenuItem key={index} value={item.name} >{item.name}</MenuItem>
            ) )
          }
         
        </Select>
        

      </FormControl>

        <FormControl className={classes.formControl}>
            <InputLabel id="credits-label">Credits</InputLabel>
            <Select
              labelId="credits-label"
              id="credits-label"
              multiple
              value={state.creditsSelected}
              input={<Input />}
              onChange={handleCredits}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value, index) => (
                    <Chip key={index} label={value} className={classes.chip} />
                  ))}
                </div>
              )}
            >

            {
              state.creditHoursDDL.map( (item, index) => (   
                <MenuItem key={index} value={item} >{item}</MenuItem>
              ) )
            }
          </Select>
        </FormControl>

            </Grid>
            <Grid item>

        <FormControlLabel control={<Switch checked={iaiChecked} onChange={handleChangeIAI} name="checkedIAI" color="primary"  />}
        label="IAI Courses"
        />
        
        <FormControl className={classes.button}>
            <Button variant="outlined" onClick={clear}>Clear All</Button>
        </FormControl>

        </Grid>

        </Grid>

      <ul>
        
          {(state.allCourses.length === 0 ) &&  <li><div className="progress"><CircularProgress  variant="indeterminate"  /> </div></li>}

          {(state.allCourses.length > 0 && state.courses && state.courses.length === 0 ) && <li><p>No courses available.</p></li>}

        { (state.courses) && state.courses.map((item, index) => (
          <li key={item.CRSE_ID+index}>
           
              <h2 id={item.SUBJECT + item.CATALOG_NBR } >  
                {item.SUBJECT} {item.CATALOG_NBR}: {item.COURSE_TITLE_LONG} { (item.GECC_CODE) && renderIAI(item.GECC_CODE)}
              </h2>
                <p className="prereq"><strong>Prerequisite(s)</strong><br/>
             {item.PREREQUISITE}</p>
              <p className="description">{item.CATALOG_DESCR}</p>
                 <p><strong>Credit Hours:</strong> {item.CREDIT_HRS} </p>

                {transfer(item.TRANSFER_TYPE)}
                { (item.MAJOR_CODE) &&
                <p className="GECCMajor">Major Code: {item.MAJOR_CODE}</p>}
                  {(item.GECC_CODE) && <p>IAI Course Code: {item.GECC_CODE }</p>} 
              
              
               <p> <Button title={item.SUBJECT + item.CATALOG_NBR} className={classes.courseButton} variant="outlined" onClick={toggleDrawer(!state.drawerOpen, item.SUBJECT, item.CATALOG_NBR )}>Course Offerings</Button> </p>
          </li>
        ))}
      </ul>
    </div>
    
    {<SwipeableDrawer
            anchor='right'
            open={state.drawerOpen}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}    
            className={classes.drawer} 
            role="presentation"
            >

              

            { (state.classes &&  state.classes.length > 0)  && ( 
                
               list() ) 
                
            }

            {(state.noClasses && matches)  &&
              <div><p style={{padding:"5px"}}>There are no course offerings for this class at this time.</p></div>
            }

{(state.noClasses && !matches)  &&
              <div style={{width:"340px"}}><p style={{padding:"5px"}}>There are no course offerings for this class at this time.</p></div>
            }
          
          </SwipeableDrawer>
     }

     {
      

     }
    </div> 
    <div className="main__sidebar">
              <div className="main__sidebar__item">
                
                {(state.contacts.length > 0) &&
                <div className="block"><div className="block__content">
        
                
              <h3>Contact Information</h3>
              
              {
                state.contacts.map(item => (
                  <li key={item.ID} >
                      
                    <div>
                      {(item.Name) && <span> <h4> {item.Name}</h4></span>}
                      {(item.Title) && <span>{item.Title}<br/></span>}
                      {(item.Phone) && <span><strong>Phone:</strong> {item.Phone}<br/></span>}
                      {(item.Fax) && <span><strong>Fax:</strong> {item.Fax}<br/></span>}
                      {(item.Email) && <span><strong>Email:</strong> <a href={"mailto:"+item.Email}> {item.Email}</a></span>}
                    </div>
                   
                  </li>
                  
                ))
              }
        
            </div></div>}</div>
</div>
</div>   
  );
}
//#endregion

//#endregion
export default CourseCatalog;

